import React, { FC } from 'react';
import Styles from './WorldPassPopup.module.scss';
import RichText from '../richtext';
import {
  WP_FLEX_UPGRADE,
  WP_FLEX_UPGRADE_NOT,
  FLEX_UPGRADE
} from '../../utils/constants';
import FalconButtonV2 from '../FalconButtonV2/FalconButtonV2';
import { countZero } from '../../utils/utils';

interface WorldPassPopupSchema {
  storyContent: any;
  createCartCall: () => void;
  setShowFlexPopUp: (a: boolean) => void;
  sessionFlexData: any;
}

const WorldPassPopup: FC<WorldPassPopupSchema> = ({
  storyContent,
  createCartCall,
  setShowFlexPopUp,
  sessionFlexData
}) => {
  const handleContinue = () => {
    setShowFlexPopUp(false);
    createCartCall();
  };

  return (
    <div className={Styles.worldPassContainer}>
      {(storyContent?.body || []).map((data: any, i: number) => {
        return (sessionFlexData?.hardwareVariant?.insuranceName === FLEX_UPGRADE &&
          data?.category === WP_FLEX_UPGRADE) ||
          (sessionFlexData?.hardwareVariant?.insuranceName === '' &&
            data?.category === WP_FLEX_UPGRADE_NOT) ? (
          <>
            {data?.title && <div className={Styles.worldPassHeader}>{data?.title}</div>}
            <div className={Styles.worldPassBody}>
              {data?.description && (
                <div className={Styles.worldPassDescription}>
                  <RichText content={data?.description} />
                </div>
              )}
              <div className={Styles.worldPassSubBody}>
                {data?.benefitBadge && <div className={Styles.benefits}>{data?.benefitBadge}</div>}
                <div className='d-flex justify-content-between align-items-center'>
                  {data?.benefitTitle && (
                    <span className={Styles.worldPassSubBodyHeader}>{data?.benefitTitle}</span>
                  )}
                  {data?.discountText && (
                    <span className={Styles.freeText}>
                      {data?.discountText}
                      <span className={Styles.price}>
                        {countZero(sessionFlexData?.hardwareVariant?.insurancePrice)}
                      </span>
                    </span>
                  )}
                </div>
                {data?.benefitDescription && (
                  <div className={Styles.worldPassBenefitDescription}>
                    <RichText content={data?.benefitDescription} />
                  </div>
                )}
              </div>
            </div>
            {data?.btn?.[0]?.buttonLabel && (
              <FalconButtonV2 content={data?.btn?.[0]} onClick={handleContinue} />
            )}
          </>
        ) : (
          <></>
        );
      })}
    </div>
  );
};

export default WorldPassPopup;
